import React from 'react';

const UploadPrintPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
				navbar: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/admin/queue/:queueId',
			exact: true,
			component: React.lazy(() => import('./UploadPrintPage')),
		},
	],
};

export default UploadPrintPageConfig;
